import AjaxForm from './AjaxForm';

export default class EnrollmentForm extends AjaxForm {
	constructor(element) {
		super(element);

		this.$form.elements.addAttendee.on('click', (e) => {
			this.addAttendeeRow(e);
		});

		$('.remove-attendee').on('click', (e) => {
			this.removeAttendeeRow(e);
		});

		$('.payment-methods .methods input').on('change', function () {
			if (!$(this).is(':checked')) {
				return;
			}

			if ($(this).attr('id') == 'cc-payment-radio') {
				$('#po-number-field').addClass('hide');
				$('#enrollment-form').attr(
					'data-form-name',
					'enrollment form - credit card'
				);
			} else {
				$('#po-number-field').removeClass('hide');
				$('#enrollment-form').attr(
					'data-form-name',
					'enrollment form - purchase order'
				);
			}

			if (window.dataLayer) {
				var form_name = $('#enrollment-form').attr('data-form-name');
				window.dataLayer.push({ form_name: form_name });
			}
		});
	}

	handleError(data, textStatus, jqXHR) {
		super.handleError(data, textStatus, jqXHR);

		window.grecaptcha.reset();
	}

	handleSuccess(data, textStatus, jqXHR) {
		super.handleSuccess(data, textStatus, jqXHR);

		if ($('#po-payment-radio').is(':checked')) {
			// Show the 2FA modal
			$.each(this.inputs, (name, field) => field.disable());

			this.$form.elements.submit.attr('disabled', 'disabled');

			$.magnificPopup.open({
				items: {
					src: '#email-two-factor-modal',
				},
				type: 'inline',
			});

			var submission_id = data.two_factor.id;
			var session_id = data.two_factor.session_id;
			var email = $('#email_Email').val();
			var phone = $('#phone').val();

			$('#email-two-factor-modal #submission_id').val(submission_id);
			$('#email-two-factor-modal #session_id').val(session_id);
			$('#email-two-factor-modal #email-input').val(email);
			$('#email-two-factor-modal #phone-input').val(phone);
		} else {
			window.location =
				window.location.protocol +
				'//' +
				window.location.host.replace('wareinc', 'boilerwarehouse') +
				'/checkout?token=' +
				data;
		}
	}
	addAttendeeRow(e) {
		e.preventDefault();

		const rowIndex = $('.attendee-row').length;

		var $r = $('#hidden-attendee-row').clone();
		var rContents = $r
			.html()
			.replace('ATTENDEENUM', rowIndex + 1)
			.replace(/ROWINDEX/g, rowIndex);
		$r.attr('id', 'attendee-row-' + rowIndex)
			.addClass('attendee-row')
			.html(rContents);

		$('#attendee-rows').append($r);

		this.$form.refresh();
		this.buildInputs();

		$('.remove-attendee').on('click', (e) => {
			this.removeAttendeeRow(e);
		});

		$('html, body').animate(
			{
				scrollTop: $('#attendee-row-' + rowIndex).offset().top - 66,
			},
			1000
		);
	}

	removeAttendeeRow(e) {
		e.preventDefault();
		var target = $(e.target);
		if (target.is('div.remove-attendee')) {
			const divId = Number(
				target.closest('.attendee-row').attr('id').replace('attendee-row-', '')
			);
			target.closest('.attendee-row').remove();
			$('.attendee-row').each(function (index) {
				if (index >= divId) {
					const r =
						Number(
							$(this).find('.subheading').html().replace('Attendee ', '')
						) - 1;

					$(this)
						.find('.subheading')
						.html('Attendee ' + (index + 1));
					$(this).attr('id', 'attendee-row-' + index);

					$(this)
						.find('label')
						.each(function () {
							var thisFor = $(this)
								.attr('for')
								.replace('.' + r + '.', '.' + index + '.');
							$(this).attr('for', thisFor);
						});

					$(this)
						.find('input,select')
						.each(function () {
							var thisId = $(this)
								.attr('id')
								.replace('.' + r + '.', '.' + index + '.');
							var thisName = $(this)
								.attr('name')
								.replace('[' + r + ']', '[' + index + ']');
							$(this).attr('id', thisId);
							$(this).attr('name', thisName);
						});
				}
			});

			this.$form.refresh();
			this.buildInputs();

			$('.remove-attendee').on('click', (e) => {
				this.removeAttendeeRow(e);
			});
		}
	}
}
